/**
 * AI Workspace Constants
 * Centralized configuration for AI actions
 */

// Available languages for translation and response generation
export const LANGUAGES = [
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
];

// Maximum languages that can be selected at once
export const MAX_LANGUAGES = 3;

// Maximum messages that can be selected
export const MAX_SELECTED_MESSAGES = 10;

// Maximum regenerations per result
export const MAX_REGENERATIONS = 3;

// Allowed message types for selection (text + multimodal supported by InfinitAgents)
export const ALLOWED_MESSAGE_TYPES = [
  'conversation',
  'extendedTextMessage',
  'imageMessage',
  'audioMessage',
  'videoMessage',
  'documentMessage',
];

// Tipos não suportados pelo AI Workspace — sticker é ruído, vCard/localização
// não viram `file` multimodal no agente da InfinitAgents.
export const BLOCKED_MESSAGE_TYPES = [
  'stickerMessage',
  'contactMessage',
  'locationMessage',
];

// Alias semântico — mesma lista, nome mais claro para uso futuro.
export const UNSUPPORTED_MESSAGE_TYPES = BLOCKED_MESSAGE_TYPES;

// Action types
export const ACTION_TYPES = {
  TRANSLATE: 'translate',
  GENERATE: 'generate',
  CUSTOM: 'custom', // Custom prompt action
};

// Action configurations
export const ACTIONS_CONFIG = {
  [ACTION_TYPES.TRANSLATE]: {
    id: ACTION_TYPES.TRANSLATE,
    label: 'Traduzir',
    icon: 'Languages',
    description: 'Traduzir texto do input',
    requiresLanguage: true,
    requiresInputText: true,
    requiresSelectedMessages: false,
    maxLanguages: 3,
    badgeColor: { bg: 'rgba(59, 130, 246, 0.2)', text: '#60a5fa' },
    badgeLabel: 'Tradução',
  },
  [ACTION_TYPES.GENERATE]: {
    id: ACTION_TYPES.GENERATE,
    label: 'Resposta Rápida',
    icon: 'Sparkles',
    description: 'Gerar uma resposta rápida com base nas mensagens selecionadas',
    requiresLanguage: true,
    requiresInputText: false,
    requiresSelectedMessages: true,
    maxLanguages: 3,
    badgeColor: { bg: 'rgba(168, 85, 247, 0.2)', text: '#a78bfa' },
    badgeLabel: 'Gerado',
  },
  [ACTION_TYPES.CUSTOM]: {
    id: ACTION_TYPES.CUSTOM,
    label: 'Chamar o Agente',
    icon: 'MessageSquarePlus',
    description: 'Falar com o agente de IA sobre essa conversa',
    requiresLanguage: false,
    requiresInputText: false,
    requiresSelectedMessages: false,
    maxLanguages: 1,
    badgeColor: { bg: 'rgba(236, 72, 153, 0.2)', text: '#f472b6' },
    badgeLabel: 'Agente',
  },
};

// Workspace states
export const WORKSPACE_STATES = {
  IDLE: 'idle',
  SELECTING_OPTIONS: 'selecting_options',
  PROCESSING_TRANSLATE: 'processing_translate',
  PROCESSING_GENERATE: 'processing_generate',
  SHOWING_RESULTS: 'showing_results',
  ERROR: 'error',
};

export default {
  LANGUAGES,
  MAX_LANGUAGES,
  MAX_SELECTED_MESSAGES,
  MAX_REGENERATIONS,
  ALLOWED_MESSAGE_TYPES,
  BLOCKED_MESSAGE_TYPES,
  ACTION_TYPES,
  ACTIONS_CONFIG,
  WORKSPACE_STATES,
};